import type { AccessRequestNodeFragment } from '@frameio/access-requests/gql/fragments/generated/AccessRequestNode';
import type { NotificationAvatar } from '@frameio/graphql-client/generated';
import type { DeepPartial } from '@frameio/utils';

/**
 * @description The `formatAccessRequestAvatar` function transforms access request node data into
 * NotificationAvatar objects. This function extracts the requester user information (avatar color,
 * profile image URL, and name) from the access request data and formats it to match the
 * NotificationAvatar type structure.
 *
 * @param {AccessRequestNodeFragment | DeepPartial<AccessRequestNodeFragment>} accessRequestNodeData the access request node data containing requester user information.
 *
 * @returns {Array<Partial<NotificationAvatar>>} an array containing a single NotificationAvatar object with the requester's avatar information.
 */

export function formatAccessRequestAvatar(
  accessRequestNodeData:
    | AccessRequestNodeFragment
    | DeepPartial<AccessRequestNodeFragment>
): Array<Partial<NotificationAvatar>> {
  const { requesterUser } = accessRequestNodeData;
  const color = requesterUser?.avatarColor;
  const url = requesterUser?.profileImageUrl;
  const userName = requesterUser?.name ?? '';

  return [
    {
      __typename: 'NotificationAvatar',
      color,
      url,
      userName,
    },
  ];
}
